"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrimaryBySchema = exports.generateUUID = exports.convertFilter = exports.cloneRawData = exports.allSettled = void 0;
exports.getValueByPath = getValueByPath;
exports.isPrimitive = isPrimitive;
exports.noneValue = void 0;
exports.setValueByPath = setValueByPath;
exports.transformPrimitiveValue = transformPrimitiveValue;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _lodash = require("lodash");
var _constant = require("../constant");
var _objectPath = _interopRequireDefault(require("object-path"));
/**
 * Promise.allSettled的polyfill函数
 * @param {Array} promises Promise对象集合
 */
var allSettled = function allSettled(promises) {
  var wrappedPromises = promises.map(function (p) {
    return Promise.resolve(p).then(function (val) {
      return {
        status: 'fulfilled',
        value: val
      };
    }, function (err) {
      return {
        status: 'rejected',
        reason: err
      };
    });
  });
  return Promise.all(wrappedPromises);
};

/**
 * 克隆一个原生的数据，剔除数据树携带的子表数据依赖
 * @param {*} data 要克隆的数据对象
 */
exports.allSettled = allSettled;
var cloneRawData = function cloneRawData(data) {
  var newData = (0, _lodash.cloneDeep)(data);
  Object.keys(data).forEach(function (key) {
    if (typeof key === 'string' && key.startsWith(_constant.TABLETAG) || ['__isDepend', '__changeType', '__changeFields'].indexOf(key) > -1) {
      delete newData[key];
    }
  });
  return newData;
};

/**
 * 判断一个值是真的为空
 * @param {*} value 要判断的值
 */
exports.cloneRawData = cloneRawData;
var noneValue = function noneValue(value) {
  if (value !== 0 && !value) {
    return true;
  }
  return false;
};

/**
 * 获取uuid随机数
 * @param {*} count 长度
 * @param {*} raDix 随机取值范围
 */
exports.noneValue = noneValue;
var char = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
var generateUUID = function generateUUID() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  var raDix = arguments.length > 1 ? arguments[1] : undefined;
  var uuid = [];
  var curRaDix = raDix || char.length;
  if (count) {
    for (var i = 0; i < count; i++) uuid[i] = char[0 | Math.random() * curRaDix];
  } else {
    var rfc;
    uuid[8] = '-';
    uuid[13] = '-';
    uuid[18] = '-';
    uuid[23] = '-';
    uuid[14] = '4';
    for (var _i = 0; _i < 36; _i++) {
      if (!uuid[_i]) {
        rfc = 0 | Math.random() * 16;
        uuid[_i] = char[_i === 19 ? rfc & 0x3 | 0x8 : rfc];
      }
    }
  }
  return uuid.join('');
};
exports.generateUUID = generateUUID;
var convertFilter = function convertFilter($filter, schema) {
  if (!$filter) return;
  var filter = $filter.filter(function (item) {
    return Boolean(item.k.trim());
  });
  if (!schema || !schema.fields) {
    return filter;
  }
  var fields = schema.fields;
  var cloneFilter = (0, _lodash.cloneDeep)(filter);
  cloneFilter.forEach(function (item) {
    // 只支持第一层 把类型转一下
    var target = fields === null || fields === void 0 ? void 0 : fields.find(function (i) {
      return i.id === item.k;
    });
    if (!target || !isPrimitive(item.v)) {
      // 找不到schema或者不是值类型
      return;
    }
    transformPrimitiveValue(item, target);
  });
  return JSON.stringify(cloneFilter);
};
exports.convertFilter = convertFilter;
function isPrimitive(value) {
  var type = (0, _typeof2.default)(value);
  return value == null || type !== 'object' && type !== 'function';
}
function transformPrimitiveValue($item, target) {
  var item = $item;
  if (item.v === null) {
    return;
  }
  if (target.type === 'string') {
    item.v = String(item.v);
  }
  if (target.type === 'number' || target.type === 'integer') {
    var valNumber = Number(item.v);
    item.v = Number.isNaN(valNumber) ? item.v : valNumber;
  }
  if (target.type === 'boolean' && typeof item.v !== 'boolean') {
    if (item.v === 'true') {
      item.v = true;
    }
    if (item.v === 'false') {
      item.v = false;
    }
  }
}

/**
 * 根据path获取data的嵌套值
 * @param {*} data
 * @param {*} path
 * @returns
 */
function getValueByPath(data, path) {
  if (!data || !path) return;
  return _objectPath.default.get(data, path);
}

/**
 * 根据path设置data的嵌套值
 * @param {*} data
 * @param {*} path
 * @returns
 */
function setValueByPath(data, path, value) {
  if (!data || !path) return;
  _objectPath.default.set(data, path, value);
}

/**
 * 获取shcema的主键key：数组类型不考虑
 * @param {*} Schema
 */
var getPrimaryBySchema = function getPrimaryBySchema(schema) {
  var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // id不存在就不用找了
  if (!(schema !== null && schema !== void 0 && schema.id)) {
    return '';
  }
  var primaryKey = '';
  var key = parentKey ? "".concat(parentKey, ".").concat(schema.id) : "".concat(schema.id);
  if (schema.isPrimaryKey) {
    primaryKey = key;
  } else {
    var fields = schema.fields || [];
    for (var i = 0; i < fields.length; i++) {
      var getKey = getPrimaryBySchema(fields[i], key);
      if (getKey) {
        primaryKey = getKey;
        break;
      }
    }
  }
  return primaryKey;
};
exports.getPrimaryBySchema = getPrimaryBySchema;